module.exports = __webpack_public_path__ + "img/icon-4.056faf86.png";